import api from "@/services/api";
import { useQuery } from "@tanstack/react-query";

interface ReportsKPISFilters {
  startDate?: string;
  endDate?: string;
  sectorId?: string;
  categoryId?: string;
}

interface CategoryRankingFilters extends ReportsKPISFilters {
  valueType?: "quantity" | "percentage";
}

export const useGetReportsKPISData = (filters?: ReportsKPISFilters) => {
  return useQuery({
    queryKey: ["reports-kpis-data", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.sectorId) params.append("sectorId", filters.sectorId);
      if (filters?.categoryId) params.append("categoryId", filters.categoryId);

      const response = await api.get(`/reports/kpis?${params.toString()}`);
      return response.data;
    },
  });
};

export const useGetReportDemandEvolution = (filters?: ReportsKPISFilters) => {
  return useQuery({
    queryKey: ["report-demand-evolution", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.sectorId) params.append("sectorId", filters.sectorId);
      if (filters?.categoryId) params.append("categoryId", filters.categoryId);

      const response = await api.get(
        `/reports/demand-evolution?${params.toString()}`,
      );
      return response.data;
    },
  });
};

export const useGetReportSectorDistribution = (
  filters?: ReportsKPISFilters,
) => {
  return useQuery({
    queryKey: ["report-sector-distribution", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);

      const response = await api.get(
        `/reports/sector-distribution?${params.toString()}`,
      );
      return response.data;
    },
  });
};

export const useGetReportCategoryRanking = (
  filters?: CategoryRankingFilters,
) => {
  return useQuery({
    queryKey: ["report-category-ranking", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.valueType) params.append("valueType", filters.valueType);
      if (filters?.sectorId) params.append("sectorId", filters.sectorId);

      const response = await api.get(
        `/reports/category-ranking?${params.toString()}`,
      );
      return response.data;
    },
  });
};

export const useGetReportSectorPerformance = (filters?: ReportsKPISFilters) => {
  return useQuery({
    queryKey: ["report-sector-performance", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);

      const response = await api.get(
        `/reports/sector-performance?${params.toString()}`,
      );
      return response.data;
    },
  });
};

export const useGetReportUserMetrics = (filters?: ReportsKPISFilters) => {
  return useQuery({
    queryKey: ["report-user-metrics", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);

      const response = await api.get(
        `/reports/user-metrics?${params.toString()}`,
      );
      return response.data;
    },
  });
};
